module.exports = __webpack_public_path__ + "img/tick.5fd84073.svg";